import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Pages/PagesCss/Home.css';

const Home = () => {
  const [activeCategory, setActiveCategory] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [dropdownHeights, setDropdownHeights] = useState({});
  const dropdownRefs = useRef([]);
  const searchRef = useRef(null);

  const mathTools = [
    {
      name: "Basic Math",
      icon: (
    <svg
      width="35"
      height="35"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="2" width="18" height="20" rx="2" ry="2" />
      <line x1="3" y1="7" x2="21" y2="7" />
      <line x1="7" y1="11" x2="7" y2="15" />
      <line x1="11" y1="11" x2="11" y2="15" />
      <line x1="15" y1="11" x2="15" y2="15" />
      <line x1="19" y1="11" x2="19" y2="15" />
    </svg>
  ),
      color: "#8665e4",
      dropdown: [
        {
          title: "Arithmetic",
          links: [
            { name: "Addition Calculator", path: "/AdditionCalculator" },
        { name: "Subtraction Calculator", path: "/SubtractionCalculator" },
        { name: "Multiplication Calculator", path: "/MultiplicationCalculator" },
        { name: "Division Calculator", path: "/DivisionCalculator" },
        { name: "Percentage Calculator", path: "/PercentageCalculator" },
        { name: "Rounding Calculator", path: "/RoundingCalculator" },
        { name: "Average Calculator", path: "/AverageCalculator" },
        { name: "Sum of Series Calculator", path: "/SumOfSeriesCalculator" },
    { name: "Integer Calculator", path: "/IntegerCalculator" },
    { name: "Number Comparator", path: "/NumberComparator" }
          ]
        },
        {
          title: "Numbers",
          links: [
            { name: "Fraction Simplifier", path: "/FractionSimplifier" },
        { name: "Mixed Fraction Calculator", path: "/MixedFractionCalculator" },
        { name: "Ratio Calculator", path: "/RatioCalculator" },
        { name: "Proportion Calculator", path: "/ProportionCalculator" },
        { name: "Number Sequence Generator", path: "/NumberSequenceGenerator" },
        { name: "LCM Calculator", path: "/LCMCalculator" },
        { name: "HCF / GCD Calculator", path: "/HCFCalculator" },
        { name: "Prime Number Checker", path: "/PrimeNumberChecker" },
        { name: "Prime Factorization", path: "/PrimeFactorization" },
        { name: "Even or Odd Checker", path: "/EvenOddChecker" }
          ]
        },
        {
          title: "Advanced",
          links: [
            { name: "Exponents Calculator", path: "/ExponentsCalculator" },
        { name: "Root Calculator", path: "/RootCalculator" },
        { name: "Scientific Notation Converter", path: "/ScientificNotationConverter" },
        { name: "Significant Figures Calculator", path: "/SignificantFiguresCalculator" },
        { name: "Absolute Value Calculator", path: "/AbsoluteValueCalculator" },
        { name: "Random Number Generator", path: "/RandomNumberGenerator" },
        { name: "Cube Root Calculator", path: "/CubeRootCalculator" },
    { name: "Nth Root Calculator", path: "/NthRootCalculator" },
    { name: "Antilog Calculator", path: "/AntilogCalculator" },
    { name: "Radical Simplifier", path: "/RadicalSimplifier" }
          ]
        }
      ]
    },
    {
      name: "Geometry",
      icon: <svg
      width="35"
      height="35"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="14" width="5" height="5" />
      <circle cx="16.5" cy="16.5" r="3.5" />
      <polygon points="12,3 16,9 8,9" />
    </svg>,
      color: "#4fc7a4",
      dropdown: [
        {
          title: "2D Shapes",
          links: [
            { name: "Area of Circle", path: "/AreaCircle" },
        { name: "Area of Triangle", path: "/AreaTriangle" },
        { name: "Area of Square", path: "/AreaSquare" },
        { name: "Area of Rectangle", path: "/AreaRectangle" },
        { name: "Area of Parallelogram", path: "/AreaParallelogram" },
        { name: "Area of Trapezium", path: "/AreaTrapezium" },
        { name: "Area of Rhombus", path: "/AreaRhombus" },
        { name: "Area of Ellipse", path: "/AreaEllipse" },
        { name: "Perimeter of Circle", path: "/PerimeterCircle" },
        { name: "Perimeter of Triangle", path: "/PerimeterTriangle" },
        { name: "Perimeter of Polygon", path: "/PerimeterPolygon" },
        { name: "Coordinate Distance Calculator", path: "/CoordinateDistance" },
        { name: "Midpoint Calculator", path: "/MidpointCalculator" },
        { name: "Slope Calculator", path: "/SlopeCalculator" },
        { name: "Angle Calculator", path: "/AngleCalculator" },
        { name: "Triangle Side Solver (SSS, SAS, ASA, RHS)", path: "/TriangleSideSolver" },
        { name: "Heron’s Formula Calculator", path: "/HeronsFormulaCalculator" },
        { name: "Triangle Height Calculator", path: "/TriangleHeight" },
        { name: "Circle Sector Area", path: "/CircleSectorArea" },
        { name: "Arc Length Calculator", path: "/ArcLengthCalculator" }
          ]
        },
        {
          title: "3D Shapes",
          links: [
            { name: "Volume of Cube", path: "/VolumeCube" },
        { name: "Volume of Cuboid", path: "/VolumeCuboid" },
        { name: "Volume of Cylinder", path: "/VolumeCylinder" },
        { name: "Volume of Cone", path: "/VolumeCone" },
        { name: "Volume of Sphere", path: "/VolumeSphere" },
        { name: "Volume of Pyramid", path: "/VolumePyramid" },
        { name: "Frustum Volume Calculator", path: "/FrustumVolume" },
        { name: "Surface Area of Cube", path: "/SurfaceAreaCube" },
        { name: "Surface Area of Sphere", path: "/SurfaceAreaSphere" },
        { name: "Surface Area of Cone", path: "/SurfaceAreaCone" }
          ]
        },
        {
          title: "Triangles & Angles",
          links: [
            { name: "Triangle Solver", path: "/TriangleSolver" },
        { name: "Angle Bisector Calculator", path: "/AngleBisectorCalculator" },
        { name: "Pythagorean Theorem", path: "/PythagoreanCalculator" },
        { name: "Law of Sines/Cosines", path: "/LawSinesCosines" },
        { name: "Right Triangle Solver", path: "/RightTriangleSolver" },
        { name: "Quadrilateral Calculator", path: "/QuadrilateralCalculator" },
        { name: "Centroid Calculator", path: "/CentroidCalculator" },
        { name: "Incenter Calculator", path: "/IncenterCalculator" },
        { name: "Circumcenter Calculator", path: "/CircumcenterCalculator" },
        { name: "Orthocenter Calculator", path: "/OrthocenterCalculator" },
          ]
        }
      ]
    },
    {
      name: "Algebra",
      icon: (
    <svg
      width="35"
      height="35"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 12l4 4 8-8" />
      <path d="M14 4h6v6" />
    </svg>
  ),
      color: "#e46586",
      dropdown: [
        {
          title: "Equations",
          links: [
            { name: "Linear Equation Solver", path: "/LinearEquationSolver" },
        { name: "Quadratic Equation Solver", path: "/QuadraticEquationSolver" },
        { name: "Polynomial Calculator", path: "/PolynomialCalculator" },
        { name: "System of Equations Solver", path: "/SystemEquationsSolver" },
        { name: "Expression Evaluator", path: "/ExpressionEvaluator" },
        { name: "Inequality Calculator", path: "/InequalityCalculator" },
        { name: "Factorization Calculator", path: "/FactorizationCalculator" },
        { name: "Synthetic Division Calculator", path: "/SyntheticDivision" },
        { name: "Complex Roots Finder", path: "/ComplexRootsFinder" },
        { name: "Parabola Calculator", path: "/ParabolaCalculator" }
          ]
        },
        {
          title: "Matrices",
          links: [
            { name: "Matrix Determinant Calculator", path: "/MatrixDeterminant" },
        { name: "Matrix Inverse Calculator", path: "/MatrixInverse" },
        { name: "Matrix Addition/Subtraction", path: "/MatrixAdditionSubtraction" },
        { name: "Matrix Multiplication", path: "/MatrixMultiplication" },
        { name: "Eigenvalue Calculator", path: "/EigenvalueCalculator" },
        { name: "Matrix Rank Calculator", path: "/MatrixRank" },
    { name: "Matrix Transpose Calculator", path: "/MatrixTranspose" },
    { name: "Matrix Trace Calculator", path: "/MatrixTrace" },
    { name: "Adjugate Matrix Calculator", path: "/MatrixAdjugate" },
    { name: "Matrix Power Calculator", path: "/MatrixPower" }
          ]
        },
        {
          title: "Sequences & Series",
          links: [
            { name: "Arithmetic Sequence Calculator", path: "/ArithmeticSequence" },
        { name: "Geometric Sequence Calculator", path: "/GeometricSequence" },
        { name: "Binomial Expansion Calculator", path: "/BinomialExpansion" },
        { name: "Logarithm Calculator", path: "/LogarithmCalculator" },
        { name: "Distance Formula", path: "/DistanceFormula" },
        { name: "Fibonacci Sequence Generator", path: "/FibonacciSequence" },
        { name: "Arithmetic Series Calculator", path: "/ArithmeticSeries" },
    { name: "Geometric Series Calculator", path: "/GeometricSeries" },
    { name: "Infinite Geometric Series", path: "/InfiniteGeometricSeries" },
    { name: "Partial Sum Calculator", path: "/PartialSum" },
          ]
        },
        {
          title: "Complex Numbers",
          links: [
            { name: "Complex Number Calculator", path: "/ComplexNumberCalculator" },
        { name: "Modulus of Complex Number", path: "/ComplexModulus" },
        { name: "Complex Conjugate Calculator", path: "/ComplexConjugate" },
    { name: "Complex Argument Calculator", path: "/ComplexArgument" },
    { name: "Complex Polar Form Converter", path: "/ComplexPolarForm" },
    { name: "Euler's Formula Calculator", path: "/EulersFormula" },
    { name: "Complex Exponential Calculator", path: "/ComplexExponential" },
    { name: "Complex Logarithm Calculator", path: "/ComplexLogarithm" },
    { name: "Complex Addition/Subtraction", path: "/ComplexAddSubtract" },
          ]
        }
      ]
    },
    {
      name: "Trigonometry",
      icon: (
    <svg
      width="35"
      height="35"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 12c4-8 8 8 12 0s8 8 12 0" />
    </svg>
  ),
      color: "#65a4e4",
      dropdown: [
        {
          title: "Basic Functions",
          links: [
            { name: "Sine Calculator", path: "/SineCalculator" },
        { name: "Cosine Calculator", path: "/CosineCalculator" },
        { name: "Tangent Calculator", path: "/TangentCalculator" },
        { name: "Cot, Sec, Cosec Calculator", path: "/CotSecCosecCalculator" },
        { name: "Inverse Trig Functions", path: "/InverseTrigCalculator" },
        { name: "Trigonometric Identities Calculator", path: "/TrigIdentitiesCalculator" },
        { name: "Unit Circle Calculator", path: "/UnitCircleCalculator" },
        { name: "Reciprocal Trig Calculator", path: "/ReciprocalTrigCalculator" },
        { name: "Trig Values for Special Angles", path: "/TrigValuesSpecialAngles" },
        { name: "Trig Function Simplifier", path: "/TrigFunctionSimplifier" },
          ]
        },
        {
          title: "Solvers",
          links: [
            { name: "SOHCAHTOA Calculator", path: "/SOHCAHTOACalculator" },
        { name: "Law of Sines Calculator", path: "/LawOfSines" },
        { name: "Law of Cosines Calculator", path: "/LawOfCosines" },
        { name: "Angle of Elevation/Depression", path: "/AngleElevationDepression" },
        { name: "Oblique Triangle Solver", path: "/ObliqueTriangleSolver" },
        { name: "SSA Ambiguous Case Solver", path: "/SSAAmbiguousCaseSolver" },
        { name: "Trigonometric Equation Solver", path: "/TrigonometricEquationSolver" },
        { name: "Reference Angle Solver", path: "/ReferenceAngleSolver" },
        { name: "Angle Between Two Lines Calculator", path: "/AngleBetweenTwoLines" },
        { name: "Triangle Classification Calculator", path: "/TriangleClassificationCalculator" },
          ]
        },
        {
          title: "Conversions",
          links: [
            { name: "Degree-Radian Converter", path: "/DegreeRadianConverter" },
        { name: "Degree Minute Second Converter", path: "/DegreeMinuteSecondConverter" },
        { name: "Radian DMS Converter", path: "/RadianDMSConverter" },
        { name: "Gradian Converter", path: "/GradianConverter" },
        { name: "Decimal Degrees Converter", path: "/DecimalDegreesConverter" },
        { name: "Slope to Angle Converter", path: "/SlopeAngleConverter" },
        { name: "Coterminal Angle Calculator", path: "/CoterminalAngleCalculator" },
        { name: "Arc Measure Calculator", path: "/ArcMeasureCalculator" },
        { name: "Circle Sector Calculator", path: "/CircleSectorCalculator" },
        { name: "Rotation Sense Calculator", path: "/RotationSenseCalculator" },
        { name: "Angle Direction Converter", path: "/AngleDirectionConverter" },
        { name: "Bearing Angle Converter", path: "/BearingAngleConverter" },
        { name: "Complement & Supplement", path: "/ComplementSupplementCalculator" },
        { name: "Turn Angle Calculator", path: "/TurnAngleCalculator" },
        { name: "Angle Between Vectors", path: "/AngleBetweenVectors" },
          ]
        }
      ]
    },
    {
      name: "Calculus",
      icon: (
    <svg
      width="35"
      height="35"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 12c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6z" />
      <path d="M6 12h12" />
    </svg>
  ),
      color: "#e4a465",
      dropdown: [
        {
          title: "Differentiation",
          links: [
            { name: "Derivative Calculator", path: "/DerivativeCalculator" },
        { name: "Partial Derivative Calculator", path: "/PartialDerivativeCalculator" },
        { name: "Derivative Function Plotter", path: "/DerivativeFunctionPlotter" },
        { name: "Limit Calculator", path: "/LimitCalculator" },
        { name: "Mean Value Theorem Calculator", path: "/MeanValueTheoremCalculator" },
        { name: "Higher Order Derivative Calculator", path: "/HigherOrderDerivativeCalculator" },
        { name: "Implicit Differentiation", path: "/ImplicitDifferentiation" },
        { name: "Directional Derivative Calculator", path: "/DirectionalDerivativeCalculator" },
        { name: "Derivative at a Point", path: "/DerivativeAtPoint" },
        { name: "Logarithmic Differentiation", path: "/LogarithmicDifferentiation" }
          ]
        },
        {
          title: "Integration",
          links: [
            { name: "Integral Calculator", path: "/IntegralCalculator" },
        { name: "Area Under Curve", path: "/AreaUnderCurve" },
        { name: "Riemann Sum Calculator", path: "/RiemannSumCalculator" },
        { name: "Double Integral Calculator", path: "/DoubleIntegralCalculator" },
        { name: "Triple Integral Calculator", path: "/TripleIntegralCalculator" },
        { name: "Improper Integral Calculator", path: "/ImproperIntegralCalculator" },
        { name: "Volume of Revolution", path: "/VolumeOfRevolution" },
        { name: "Integration by Parts", path: "/IntegrationByParts" },
        { name: "Substitution Method", path: "/SubstitutionMethod" },
        { name: "Surface Area Integral", path: "/SurfaceAreaIntegral" }
          ]
        },
        {
          title: "Advanced",
          links: [
            { name: "Differential Equation Solver", path: "/DifferentialEquationsSolver" },
        { name: "Taylor Series Calculator", path: "/TaylorSeriesCalculator" },
        { name: "Laplace Transform Calculator", path: "/LaplaceTransformCalculator" },
        { name: "Inverse Laplace Transform", path: "/InverseLaplaceTransform" },
        { name: "Vector Calculus Calculator", path: "/VectorCalculusCalculator" },
        { name: "Fourier Series Calculator", path: "/FourierSeriesCalculator" },
        { name: "Green's Theorem Calculator", path: "/GreensTheoremCalculator" },
        { name: "Stokes' Theorem Calculator", path: "/StokesTheoremCalculator" },
        { name: "Divergence Theorem Calculator", path: "/DivergenceTheoremCalculator" },
        { name: "Complex Analysis Calculator", path: "/ComplexAnalysisCalculator" }
          ]
        }
      ]
    },
    {
      name: "Statistics",
      icon: (
    <svg
      width="35"
      height="35"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="4" y1="20" x2="4" y2="10" />
      <line x1="10" y1="20" x2="10" y2="4" />
      <line x1="16" y1="20" x2="16" y2="14" />
    </svg>
  ),
      color: "#a465e4",
      dropdown: [
        {
          title: "Descriptive Stats",
          links: [
            { name: "Mean Calculator", path: "/MeanCalculator" },
        { name: "Median Calculator", path: "/MedianCalculator" },
        { name: "Mode Calculator", path: "/ModeCalculator" },
        { name: "Range Calculator", path: "/RangeCalculator" },
        { name: "Standard Deviation Calculator", path: "/StandardDeviationCalculator" },
        { name: "Variance Calculator", path: "/VarianceCalculator" },
        { name: "Percentile Calculator", path: "/PercentileCalculator" },
        { name: "Quartile Calculator", path: "/QuartileCalculator" },
        { name: "Outlier Detection", path: "/OutlierDetection" },
        { name: "Interquartile Range (IQR) Calculator", path: "/InterquartileRangeCalculator" },
        { name: "Skewness Calculator", path: "/SkewnessCalculator" },
{ name: "Kurtosis Calculator", path: "/KurtosisCalculator" },
{ name: "Five Number Summary", path: "/FiveNumberSummary" },
{ name: "Coefficient of Variation", path: "/CoefficientOfVariation" },
{ name: "Data Frequency Table", path: "/DataFrequencyTable" }
          ]
        },
        {
          title: "Probability",
          links: [
            { name: "Probability Calculator", path: "/ProbabilityCalculator" },
        { name: "Permutation Calculator", path: "/PermutationCalculator" },
        { name: "Combination Calculator", path: "/CombinationCalculator" },
        { name: "Bayes Theorem Calculator", path: "/BayesTheoremCalculator" },
        { name: "Normal Distribution Calculator", path: "/NormalDistributionCalculator" },
        { name: "Binomial Distribution", path: "/BinomialDistribution" },
        { name: "Poisson Distribution", path: "/PoissonDistribution" },
        { name: "Geometric Distribution", path: "/GeometricDistribution" },
{ name: "Hypergeometric Distribution", path: "/HypergeometricDistribution" },
{ name: "Exponential Distribution", path: "/ExponentialDistribution" },
{ name: "Discrete Probability Distribution", path: "/DiscreteProbabilityDistribution" },
{ name: "Continuous Probability Distribution", path: "/ContinuousProbabilityDistribution" },
{ name: "Joint Probability Calculator", path: "/JointProbabilityCalculator" },
{ name: "Conditional Probability", path: "/ConditionalProbability" },
{ name: "Random Variable Calculator", path: "/RandomVariableCalculator" }
          ]
        },
        {
          title: "Statistical Tests",
          links: [
            { name: "Z-Score Calculator", path: "/ZScoreCalculator" },
        { name: "p-value Calculator", path: "/PValueCalculator" },
        { name: "T-test Calculator", path: "/TTestCalculator" },
        { name: "Chi-square Calculator", path: "/ChiSquareCalculator" },
        { name: "Correlation Coefficient", path: "/CorrelationCoefficient" },
        { name: "Regression Calculator", path: "/RegressionCalculator" },
        { name: "ANOVA Calculator", path: "/AnovaCalculator" },
{ name: "Confidence Interval Calculator", path: "/ConfidenceInterval" },
{ name: "F-Test Calculator", path: "/FTestCalculator" },
{ name: "Covariance Calculator", path: "/CovarianceCalculator" },
{ name: "Paired T-Test Calculator", path: "/PairedTTestCalculator" },
{ name: "One Sample T-Test", path: "/OneSampleTTest" },
{ name: "Two Sample T-Test", path: "/TwoSampleTTest" },
{ name: "Spearman Rank Correlation", path: "/SpearmanCorrelationCalculator" },
{ name: "Pearson Correlation Test", path: "/PearsonCorrelation" }
          ]
        }
      ]
    },
    {
      name: "Financial",
      icon: (
    <svg
      width="35"
      height="35"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="6" width="20" height="12" rx="2" />
      <circle cx="12" cy="12" r="3" />
      <path d="M6 12h.01M18 12h.01" />
    </svg>
  ),
      color: "#65e486",
      dropdown: [
        {
          title: "Time Value of Money",
          links: [
            { name: "Present Value Calculator", path: "/PresentValueCalculator" },
        { name: "Future Value Calculator", path: "/FutureValueCalculator" },
        { name: "Simple Interest Formula", path: "/SimpleInterestCalculator" },
        { name: "Compound Interest Formula", path: "/CompoundInterestCalculator" },
        { name: "Continuous Compounding Calculator", path: "/ContinuousCompoundingCalculator" },
        { name: "Discount Factor Calculator", path: "/DiscountFactorCalculator" },
        { name: "Accumulation Factor Calculator", path: "/AccumulationFactorCalculator" },
        { name: "Effective Interest Rate Calculator", path: "/EffectiveInterestRateCalculator" },
        { name: "Nominal Interest Rate Calculator", path: "/NominalInterestRateCalculator" },
        { name: "Interest Conversion Calculator", path: "/InterestConversionCalculator" },
        { name: "Force of Interest Calculator", path: "/ForceOfInterestCalculator" },
  { name: "Equivalent Interest Rate Calculator", path: "/EquivalentInterestRateCalculator" },
  { name: "Accumulated Value Calculator", path: "/AccumulatedValueCalculator" },
  { name: "Discount Rate Conversion Calculator", path: "/DiscountRateConversion" },
  { name: "Time Period Calculator (Interest)", path: "/InterestTimePeriodCalculator" }
          ]
        },
        {
          title: "Annuities & Cash Flows",
          links: [
            { name: "Ordinary Annuity Calculator", path: "/OrdinaryAnnuityCalculator" },
        { name: "Annuity Due Calculator", path: "/AnnuityDueCalculator" },
        { name: "Perpetuity Calculator", path: "/PerpetuityCalculator" },
        { name: "Cash Flow Present Value", path: "/CashFlowPresentValue" },
        { name: "Cash Flow Future Value", path: "/CashFlowFutureValue" },
        { name: "Growing Annuity Calculator", path: "/GrowingAnnuityCalculator" },
        { name: "Deferred Annuity Calculator", path: "/DeferredAnnuityCalculator" },
        { name: "Annuity Factor Calculator", path: "/AnnuityFactorCalculator" },
        { name: "Sinking Fund Calculator", path: "/SinkingFundCalculator" },
        { name: "Capital Recovery Factor", path: "/CapitalRecoveryFactor" },
        { name: "Annuity Payment Calculator", path: "/AnnuityPaymentCalculator" },
  { name: "Outstanding Loan Balance Calculator", path: "/OutstandingLoanBalanceCalculator" },
  { name: "Amortization Factor Calculator", path: "/AmortizationFactorCalculator" },
  { name: "Gradient Annuity Calculator", path: "/GradientAnnuityCalculator" },
  { name: "Equivalent Annual Worth Calculator", path: "/EquivalentAnnualWorthCalculator" }
          ]
        },
        {
          title: "Financial Rates & Valuation",
          links: [
            { name: "Net Present Value (NPV)", path: "/NetPresentValueCalculator" },
        { name: "Internal Rate of Return (IRR)", path: "/InternalRateOfReturnCalculator" },
        { name: "Modified IRR (MIRR)", path: "/ModifiedIRRCalculator" },
        { name: "Discount Rate Calculator", path: "/DiscountRateCalculator" },
        { name: "Yield to Maturity (YTM)", path: "/YieldToMaturityCalculator" },
        { name: "Bond Price Calculator", path: "/BondPriceCalculator" },
        { name: "Bond Duration Calculator", path: "/BondDurationCalculator" },
        { name: "Bond Convexity Calculator", path: "/BondConvexityCalculator" },
        { name: "Payback Period Calculator", path: "/PaybackPeriodCalculator" },
        { name: "Profitability Index", path: "/ProfitabilityIndexCalculator" },
        { name: "Holding Period Return Calculator", path: "/HoldingPeriodReturnCalculator" },
  { name: "Spot Rate Calculator", path: "/SpotRateCalculator" },
  { name: "Forward Rate Calculator", path: "/ForwardRateCalculator" },
  { name: "Zero-Coupon Bond Calculator", path: "/ZeroCouponBondCalculator" },
  { name: "Capital Asset Pricing Model (CAPM)", path: "/CapitalAssetPricingModelCalculator" }
          ]
        }
      ]
    },
    {
      name: "Converters",
      icon: (
    <svg
      width="35"
      height="35"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 3l4 4-4 4" />
      <path d="M20 7H8" />
      <path d="M8 21l-4-4 4-4" />
      <path d="M4 17h12" />
    </svg>
  ),
      color: "#e46565",
      dropdown: [
        {
          title: "Unit Converters",
          links: [
            { name: "Length Converter", path: "/LengthConverter" },
        { name: "Weight Converter", path: "/WeightConverter" },
        { name: "Temperature Converter", path: "/TemperatureConverter" },
        { name: "Area Converter", path: "/AreaConverter" },
        { name: "Volume Converter", path: "/VolumeConverter" },
        { name: "Speed Converter", path: "/SpeedConverter" },
        { name: "Time Converter", path: "/TimeConverter" },
        { name: "Pressure Converter", path: "/PressureConverter" },
        { name: "Energy Converter", path: "/EnergyConverter" },
        { name: "Power Converter", path: "/PowerConverter" },
        { name: "Force Converter", path: "/ForceConverter" },
        { name: "Density Converter", path: "/DensityConverter" },
        { name: "Angle Converter", path: "/AngleConverter" },
        { name: "Frequency Converter", path: "/FrequencyConverter" },
        { name: "Torque Converter", path: "/TorqueConverter" },
        { name: "Fuel Efficiency Converter", path: "/FuelEfficiencyConverter" },
        { name: "Sound Level Converter", path: "/SoundLevelConverter" },
        { name: "Illumination Converter", path: "/IlluminationConverter" },
        { name: "Magnetic Field Converter", path: "/MagneticFieldConverter" },
        { name: "Viscosity Converter", path: "/ViscosityConverter" }
          ]
        },
        {
          title: "Digital & Number",
          links: [
            { name: "Data Storage Converter", path: "/DataStorageConverter" },
        { name: "Base Number Converter", path: "/BaseNumberConverter" },
        { name: "Binary Calculator", path: "/BinaryCalculator" },
        { name: "Hexadecimal Calculator", path: "/HexadecimalCalculator" },
        { name: "Roman Numeral Converter", path: "/RomanNumeralConverter" },
        { name: "Octal Calculator", path: "/OctalCalculator" },
        { name: "Decimal to Binary Converter", path: "/DecimalToBinaryConverter" },
        { name: "Decimal to Hexadecimal Converter", path: "/DecimalToHexadecimalConverter" },
        { name: "Binary to Decimal Converter", path: "/BinaryToDecimalConverter" },
        { name: "Hexadecimal to Decimal Converter", path: "/HexadecimalToDecimalConverter" },
        { name: "Binary to Hexadecimal Converter", path: "/BinaryToHexadecimalConverter" },
        { name: "Hexadecimal to Binary Converter", path: "/HexadecimalToBinaryConverter" },
        { name: "Binary to Octal Converter", path: "/BinaryToOctalConverter" },
        { name: "Octal to Binary Converter", path: "/OctalToBinaryConverter" },
        { name: "Octal to Decimal Converter", path: "/OctalToDecimalConverter" },
        { name: "Decimal to Octal Converter", path: "/DecimalToOctalConverter" },
        { name: "Number System Calculator", path: "/NumberSystemCalculator" },
        { name: "Bitwise Calculator", path: "/BitwiseCalculator" },
        { name: "ASCII Converter", path: "/ASCIIConverter" },
        { name: "Unicode Converter", path: "/UnicodeConverter" }
          ]
        }
      ]
    },
    { 
      name: "Advanced Math",
      icon: (
    <svg
      width="35"
      height="35"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 17c3-6 6-6 9 0s6 6 9 0" />
      <line x1="3" y1="3" x2="3" y2="21" />
      <line x1="3" y1="21" x2="21" y2="21" />
    </svg>
  ),
      color: "#e4d165",
      dropdown: [
        {
          title: "Special Functions",
          links: [
            { name: "Fibonacci Calculator", path: "/FibonacciCalculator" },
        { name: "Factorial Calculator", path: "/FactorialCalculator" },
        { name: "Prime Counting Function", path: "/PrimeCountingFunction" },
        { name: "Prime Factorization", path: "/PrimeFactorizationCalculator" },
        { name: "Modular Arithmetic Calculator", path: "/ModularArithmeticCalculator" },
        { name: "Continued Fraction Calculator", path: "/ContinuedFractionCalculator" },
        { name: "Galois Field Calculator", path: "/GaloisFieldCalculator" },
        { name: "Collatz Sequence Calculator", path: "/CollatzSequenceCalculator" },
        { name: "Sequence Pattern Calculator", path: "/SequencePatternCalculator" },
        { name: "Number Base Pattern Detector", path: "/NumberBasePatternDetector" },
        { name: "Lucas Number Calculator", path: "/LucasNumbersCalculator" },
{ name: "Bernoulli Numbers Calculator", path: "/BernoulliNumbersCalculator" },
{ name: "Euler Totient Function", path: "/EulerTotientFunction" },
{ name: "Partition Function Calculator", path: "/PartitionFunctionCalculator" },
{ name: "Mobius Function Calculator", path: "/MobiusFunctionCalculator" }
          ]
        },
        {
          title: "Advanced Tools",
          links: [
            { name: "Fourier Transform Calculator", path: "/FourierTransformCalculator" },
        { name: "Probability Density Function Viewer", path: "/ProbabilityDensityFunctionViewer" },
        { name: "Combinatorial Sum Calculator", path: "/CombinatorialSumCalculator" },
        { name: "Random Matrix Generator", path: "/RandomMatrixGenerator" },
        { name: "Linear Programming Solver", path: "/LinearProgrammingSolver" },
        { name: "Optimization Calculator", path: "/OptimizationCalculator" },
        { name: "Step Function Calculator", path: "/StepFunctionCalculator" },
        { name: "Hash Calculator (MD5, SHA1, SHA256)", path: "/HashCalculator" },
        { name: "Z-Transform Calculator", path: "/ZTransformCalculator" },
{ name: "Inverse Z-Transform", path: "/InverseZTransformCalculator" },
{ name: "Wavelet Transform Calculator", path: "/WaveletTransformCalculator" },
{ name: "Discrete Cosine Transform (DCT)", path: "/DiscreteCosineTransformCalculator" },
{ name: "Singular Value Decomposition (SVD)", path: "/SingularValueDecompositionCalculator" },
{ name: "Markov Chain Calculator", path: "/MarkovChainCalculator" },
{ name: "Numerical Integration Calculator", path: "/NumericalIntegrationCalculator" }
          ]
        },
        {
          title: "Regression & Graphing",
          links: [
            { name: "Graph Plotter", path: "/GraphPlotter" },
        { name: "Logarithmic Regression", path: "/LogarithmicRegressionCalculator" },
        { name: "Exponential Regression", path: "/ExponentialRegressionCalculator" },
        { name: "Linear Regression Calculator", path: "/LinearRegressionCalculator" },
{ name: "Polynomial Regression", path: "/PolynomialRegressionCalculator" },
{ name: "Multiple Regression Calculator", path: "/MultipleRegressionCalculator" },
{ name: "Logistic Regression", path: "/LogisticRegressionCalculator" },
{ name: "Power Regression", path: "/PowerRegressionCalculator" },
{ name: "Piecewise Function Plotter", path: "/PiecewiseFunctionPlotter" },
{ name: "Parametric Graph Plotter", path: "/ParametricGraphPlotter" },
{ name: "Polar Graph Plotter", path: "/PolarGraphPlotter" },
{ name: "3D Surface Plotter", path: "/SurfacePlotter" },
{ name: "Residual Plot Generator", path: "/ResidualPlotGenerator" },
{ name: "Best Fit Curve Finder", path: "/BestFitCurveFinder" },
{ name: "Scatter Plot Generator", path: "/ScatterPlotGenerator" }
          ]
        }
      ]
    }
  ];

  // Calculate dropdown heights when component mounts
  useEffect(() => {
    const heights = {};
    dropdownRefs.current.forEach((ref, index) => {
      if (ref) {
        heights[index] = ref.scrollHeight;
      }
    });
    setDropdownHeights(heights);
  }, [mathTools]);

  // Close suggestions when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Generate search suggestions
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setSearchSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    const allTools = [];
    mathTools.forEach(category => {
      category.dropdown.forEach(section => {
        section.links.forEach(link => {
          allTools.push({
            name: link.name,
            path: link.path,
            category: category.name,
            categoryColor: category.color
          });
        });
      });
    });

    const filtered = allTools.filter(tool =>
      tool.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      tool.category.toLowerCase().includes(searchTerm.toLowerCase())
    ).slice(0, 8); // Limit to 8 suggestions

    setSearchSuggestions(filtered);
    setShowSuggestions(true);
  }, [searchTerm, mathTools]);

  const toggleCategory = (index) => {
    setActiveCategory(activeCategory === index ? null : index);
  };

  const handleSuggestionClick = (path) => {
    setSearchTerm('');
    setShowSuggestions(false);
    // You can navigate to the tool here if needed
  };

  // Filter tools based on search
  const filteredTools = mathTools.filter(category => 
    searchTerm === '' ||
    category.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    category.dropdown.some(section => 
      section.links.some(link => 
        link.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
  );

  const getTotalTools = () => {
    return mathTools.reduce((total, category) => {
      return total + category.dropdown.reduce((sectionTotal, section) => {
        return sectionTotal + section.links.length;
      }, 0);
    }, 0);
  };

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Comprehensive <span className="gradient-text">Math Calculator</span> Suite
            </h1>
            <p className="hero-description">
              Access {getTotalTools()}+ powerful math tools for students, teachers, and professionals. 
              Fast, accurate, and completely free to use.
            </p>
            
            {/* Search Bar with Suggestions */}
            <div className="search-container" ref={searchRef}>
              <div className="search-box">
                <i className="fa-solid fa-magnifying-glass search-icon"></i>
                <input
                  type="text"
                  placeholder="Search for calculators and tools..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onFocus={() => searchTerm && setShowSuggestions(true)}
                  className="search-input"
                />
                {searchTerm && (
                  <button 
                    className="search-clear"
                    onClick={() => {
                      setSearchTerm('');
                      setShowSuggestions(false);
                    }}
                  >
                    <i className="fa-solid fa-times"></i>
                  </button>
                )}
              </div>

              {/* Search Suggestions */}
              {showSuggestions && searchSuggestions.length > 0 && (
                <div className="search-suggestions">
                  {searchSuggestions.map((suggestion, index) => (
                    <Link
                      key={index}
                      to={suggestion.path}
                      className="suggestion-item"
                      onClick={() => handleSuggestionClick(suggestion.path)}
                    >
                      <div className="suggestion-info">
                        <span className="suggestion-name">{suggestion.name}</span>
                        <span 
                          className="suggestion-category"
                          style={{ color: suggestion.categoryColor }}
                        >
                          {suggestion.category}
                        </span>
                      </div>
                      <i className="fa-solid fa-arrow-right suggestion-arrow"></i>
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {/* Quick Stats */}
            <div className="quick-stats">
              <div className="stat">
                <span className="stat-number">{getTotalTools()}+</span>
                <span className="stat-label">Tools</span>
              </div>
              <div className="stat">
                <span className="stat-number">{mathTools.length}</span>
                <span className="stat-label">Categories</span>
              </div>
              <div className="stat">
                <span className="stat-number">100%</span>
                <span className="stat-label">Free</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tools Grid Section */}
      <section className="tools-section">
        <div className="container">
          <div className="section-header-1">
            <h2>Math Calculator Categories</h2>
            <p>Browse our comprehensive collection of mathematical tools</p>
          </div>

          <div className="tools-grid">
            {filteredTools.map((category, index) => (
              <div 
                key={index}
                className={`tool-category ${activeCategory === index ? 'active' : ''}`}
              >
                <div 
                  className="category-header"
                  onClick={() => toggleCategory(index)}
                  style={{ '--category-color': category.color }}
                >
                  <div className="category-icon">
                    <span className="menu-icon">{category.icon}</span>
                  </div>
                  <div className="category-info">
                    <h3 className="category-name">{category.name}</h3>
                    <span className="tool-count">
                      {category.dropdown.reduce((total, section) => total + section.links.length, 0)} tools
                    </span>
                  </div>
                  <div className="category-arrow">
                    <i className={`fa-solid fa-chevron-${activeCategory === index ? 'up' : 'down'}`}></i>
                  </div>
                </div>

                <div 
                  className="category-dropdown"
                  ref={el => dropdownRefs.current[index] = el}
                  style={{
                    maxHeight: activeCategory === index ? `${dropdownHeights[index]}px` : '0px'
                  }}
                >
                  {category.dropdown.map((section, sectionIndex) => (
                    <div key={sectionIndex} className="dropdown-section">
                      <h4 className="section-title">{section.title}</h4>
                      <div className="section-links">
                        {section.links.map((link, linkIndex) => (
                          <Link
                            key={linkIndex}
                            to={link.path}
                            className="tool-link"
                          >
                            <span className="tool-name">{link.name}</span>
                            <i className="fa-solid fa-arrow-right link-arrow"></i>
                          </Link>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {filteredTools.length === 0 && (
            <div className="no-results">
              <i className="fa-solid fa-search"></i>
              <h3>No tools found</h3>
              <p>Try adjusting your search terms</p>
            </div>
          )}
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fa-solid fa-bolt"></i>
              </div>
              <h3>Fast & Accurate</h3>
              <p>Get instant results with precise calculations powered by advanced algorithms.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fa-solid fa-lock"></i>
              </div>
              <h3>Privacy Focused</h3>
              <p>All calculations happen in your browser. We never store your data.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fa-solid fa-mobile-screen"></i>
              </div>
              <h3>Mobile Friendly</h3>
              <p>Use our tools seamlessly on any device with responsive design.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;